import { render } from "./EventTypeForm.vue?vue&type=template&id=281b8604"
import script from "./EventTypeForm.vue?vue&type=script&lang=js"
export * from "./EventTypeForm.vue?vue&type=script&lang=js"

import "./EventTypeForm.vue?vue&type=style&index=0&id=281b8604&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__